import { mapState, mapActions } from 'vuex'
import createApp from 'createApp'
const categoryHomeJumbo = () => import('Components/CategoryDirectory/categoryHomeJumbo.vue')
const categoryHomeNav = () => import('Components/CategoryDirectory/categoryHomeNav.vue')
const categoryHomeShelf = () => import('Components/CategoryDirectory/categoryHomeShelf.vue')
const categorySupplier = () => import('Components/CategoryDirectory/categorySupplier.vue')
const categoryHomeShelfBox = () => import('Components/CategoryDirectory/categoryHomeShelfBox.vue')
const categoryShortcuts = () => import('Components/CategoryDirectory/categoryShortcuts.vue')
import { getInterfacePreference } from 'Services/interfacePreferenceManager'
import { interfaceRegionTypes, cardViewTypes } from 'Enums/interfacePreferenceTypes'
import { StoreState } from 'Types'

createApp({
  components: {
    categoryHomeJumbo,
    categoryHomeNav,
    categoryHomeShelf,
    categorySupplier,
    categoryHomeShelfBox,
    categoryShortcuts,
  },

  mounted() {
    const cardViewPreference = getInterfacePreference(interfaceRegionTypes.directoryCardView)

    if (cardViewPreference !== cardViewTypes.none) {
      this.updateCategorySelected({ mode: cardViewPreference })
    }
  },

  computed: {
    ...mapState({
      groupList: (state: StoreState) => state.navigation.groupList,
    })
  },

  methods: {
    ...mapActions({
      updateCategorySelected: 'categoryDirectory/updateCategorySelected'
    })
  },
})